module.exports = __webpack_public_path__ + "static/media/image-992.f895f6b8.jpg";